<section class="ups-section text-white">
  <div class="ups-container d-flex align-items-center justify-content-between">
    <span><i class="icon-cake"></i>
      <ui-no-br-after text="{{'common.ups.orderFromLocalBakeries' | translate}}"></ui-no-br-after>
    </span>
    <span><i class="icon-circle-money"></i>
    <ui-no-br-after text="{{'common.ups.noExtraCost' | translate}}"></ui-no-br-after>
    </span>
    <span><i class="icon-happy"></i>
    <ui-no-br-after text="{{'common.ups.lotsOfCustomers' | translate}}"></ui-no-br-after></span>
  </div>
</section>